var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulkBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 17,
    viewBox: "0 0 10 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.51671L8.47472 0L0 8.48329L8.48329 16.9666L10 15.4499L3.03342 8.48329L10 1.51671Z",
    fill: "#4F4E51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkBackIcon);
export default __webpack_public_path__ + "static/media/bulkBackIcon.6c42f68c76bbdc5e4a0ca5507c4b6e8d.svg";
export { ForwardRef as ReactComponent };